module.exports = __webpack_public_path__ + "img/dizhi2.784294e8.svg";